var map = {
	"./AAF2021-1.jpg": 6056,
	"./AAF2021-2.jpg": 8903,
	"./AAF2021-3.jpg": 6746,
	"./AAF2021-4.jpg": 2489,
	"./AAF2021-5.jpg": 4492,
	"./AAF2021-6.jpg": 9659,
	"./AAF2021.png": 1350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;